import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#0B1121] py-24">
      <div className="container-custom max-w-4xl">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#5CBDB0] hover:underline mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla Home
        </Link>

        <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-8">
          Informativa sulla Privacy
        </h1>

        <div className="prose prose-invert prose-lg max-w-none">
          <div className="text-white/70 space-y-6">
            <p className="text-white/50 text-sm">
              Ultimo aggiornamento: 15 Maggio 2026
            </p>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                1. Titolare del Trattamento
              </h2>
              <p>
                Il Titolare del trattamento dei dati personali è:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">F&P IDEA S.R.L.S.</strong> (marchio DODIPA in concessione esclusiva)</li>
                <li>Sede legale: Corso Pietro Giannone 1/A, 71121 Foggia (FG)</li>
                <li>P.IVA / C.F.: 04328400710</li>
                <li>REA: FG-318897</li>
                <li>Email: info@dodipa.it</li>
                <li>PEC: fpidea@pec.it</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                2. Tipologie di Dati Raccolti
              </h2>
              <p>
                I dati personali raccolti attraverso questo sito web includono:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Dati identificativi:</strong> nome, cognome, indirizzo email, numero di telefono</li>
                <li><strong className="text-white">Dati aziendali:</strong> nome dell'azienda (facoltativo)</li>
                <li><strong className="text-white">Dati di navigazione:</strong> indirizzo IP, browser utilizzato, pagine visitate</li>
                <li><strong className="text-white">Dati forniti volontariamente:</strong> contenuto dei messaggi inviati tramite il form di contatto</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                3. Finalità del Trattamento
              </h2>
              <p>I dati personali sono trattati per le seguenti finalità:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Rispondere alle richieste di contatto</strong> inviate tramite il form</li>
                <li><strong className="text-white">Fornire consulenza</strong> in materia di energia e finanza agevolata</li>
                <li><strong className="text-white">Adempimenti di legge</strong> e obblighi contrattuali</li>
                <li><strong className="text-white">Marketing diretto</strong> (solo previo consenso esplicito)</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                4. Base Giuridica del Trattamento
              </h2>
              <p>Il trattamento dei dati personali si basa su:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Consenso dell'interessato</strong> (Art. 6, par. 1, lett. a) GDPR)</li>
                <li><strong className="text-white">Esecuzione di un contratto</strong> (Art. 6, par. 1, lett. b) GDPR)</li>
                <li><strong className="text-white">Adempimento di obblighi legali</strong> (Art. 6, par. 1, lett. c) GDPR)</li>
                <li><strong className="text-white">Legittimo interesse del Titolare</strong> (Art. 6, par. 1, lett. f) GDPR)</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                5. Modalità di Trattamento e Conservazione
              </h2>
              <p>
                I dati personali sono trattati con strumenti automatizzati per il tempo strettamente necessario 
                a conseguire gli scopi per cui sono stati raccolti. Specifiche misure di sicurezza sono osservate 
                per prevenire la perdita dei dati, usi illeciti o non corretti ed accessi non autorizzati.
              </p>
              <p className="mt-4">
                I dati saranno conservati per un periodo massimo di 10 anni dalla cessazione del rapporto, 
                salvo diversi obblighi di legge.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                6. Comunicazione e Diffusione dei Dati
              </h2>
              <p>
                I dati personali potranno essere comunicati a:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li>Dipendenti e collaboratori del Titolare</li>
                <li>Consulenti e professionisti esterni per l'erogazione dei servizi</li>
                <li>Autorità competenti in caso di obblighi di legge</li>
                <li><strong className="text-white">Google Ireland Limited</strong> (per Google Analytics, solo previo consenso) - con IP anonimizzato e garanzie adeguate per trasferimenti extra-UE</li>
              </ul>
              <p className="mt-4">
                I dati di navigazione raccolti tramite Google Analytics sono anonimi e non consentono l'identificazione diretta dell'utente.
                Per maggiori informazioni sui cookie utilizzati, consulta la nostra <a href="/cookie-policy" className="text-[#5CBDB0] hover:underline">Cookie Policy</a>.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                6bis. Servizi di Terze Parti
              </h2>
              <p>
                Il presente sito web utilizza i seguenti servizi di terze parti per il suo funzionamento:
              </p>
              
              <h3 className="font-heading text-xl font-semibold text-white mt-6 mb-3">
                Google Fonts (Google Ireland Limited)
              </h3>
              <p>
                Google Fonts è un servizio di hosting di font di proprietà di Google Ireland Limited che permette 
                a questo sito di integrare font personalizzati. Quando l'utente visita il sito, il browser 
                scarica i font necessari dai server di Google. Questo comporta la trasmissione dell'indirizzo IP 
                dell'utente a Google.
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60 mt-2">
                <li>Dati raccolti: dati di utilizzo, indirizzo IP</li>
                <li>Luogo del trattamento: Irlanda / Stati Uniti</li>
                <li>Privacy Policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline">policies.google.com/privacy</a></li>
              </ul>

              <h3 className="font-heading text-xl font-semibold text-white mt-6 mb-3">
                PostHog (PostHog Inc.)
              </h3>
              <p>
                PostHog è un servizio di analytics e analisi del comportamento degli utenti fornito da PostHog Inc. 
                Questo servizio ci permette di comprendere come gli utenti interagiscono con il sito web al fine 
                di migliorare l'esperienza utente. I dati vengono raccolti solo previo consenso dell'utente.
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60 mt-2">
                <li>Dati raccolti: dati di utilizzo, dati di navigazione, interazioni con il sito</li>
                <li>Luogo del trattamento: Stati Uniti</li>
                <li>Privacy Policy: <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline">posthog.com/privacy</a></li>
              </ul>

              <h3 className="font-heading text-xl font-semibold text-white mt-6 mb-3">
                Servizi CDN e Hosting (Emergent / Cloudflare)
              </h3>
              <p>
                Il sito utilizza servizi di Content Delivery Network (CDN) e hosting per garantire 
                la velocità e la sicurezza del sito web. Questi servizi possono raccogliere dati tecnici 
                come l'indirizzo IP per ottimizzare la distribuzione dei contenuti e proteggere il sito 
                da attacchi informatici.
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60 mt-2">
                <li>Dati raccolti: dati di utilizzo, indirizzo IP, dati tecnici del browser</li>
                <li>Finalità: hosting, sicurezza, ottimizzazione delle prestazioni</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                7. Diritti dell'Interessato
              </h2>
              <p>
                Ai sensi degli articoli 15-22 del GDPR, l'interessato ha diritto di:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-white/60">
                <li><strong className="text-white">Accesso:</strong> ottenere conferma dell'esistenza dei propri dati</li>
                <li><strong className="text-white">Rettifica:</strong> correggere dati inesatti o incompleti</li>
                <li><strong className="text-white">Cancellazione:</strong> richiedere la cancellazione dei dati ("diritto all'oblio")</li>
                <li><strong className="text-white">Limitazione:</strong> limitare il trattamento in determinati casi</li>
                <li><strong className="text-white">Portabilità:</strong> ricevere i dati in formato strutturato</li>
                <li><strong className="text-white">Opposizione:</strong> opporsi al trattamento per motivi legittimi</li>
                <li><strong className="text-white">Revoca del consenso:</strong> revocare in qualsiasi momento il consenso prestato</li>
              </ul>
              <p className="mt-4">
                Per esercitare i propri diritti, l'interessato può inviare una richiesta a: 
                <a href="mailto:info@dodipa.it" className="text-[#5CBDB0] hover:underline ml-1">info@dodipa.it</a>
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                8. Reclamo all'Autorità di Controllo
              </h2>
              <p>
                L'interessato ha il diritto di proporre reclamo all'Autorità Garante per la Protezione 
                dei Dati Personali qualora ritenga che il trattamento dei propri dati violi il Regolamento UE 2016/679.
              </p>
              <p className="mt-4">
                <strong className="text-white">Garante per la Protezione dei Dati Personali</strong><br />
                Piazza Venezia 11, 00187 Roma<br />
                <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-[#5CBDB0] hover:underline">
                  www.garanteprivacy.it
                </a>
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mt-8 mb-4">
                9. Modifiche all'Informativa
              </h2>
              <p>
                Il Titolare si riserva il diritto di apportare modifiche alla presente informativa in qualsiasi momento, 
                dandone pubblicità agli utenti su questa pagina. Si prega di consultare periodicamente questa pagina 
                per verificare eventuali aggiornamenti.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
